// extracted by mini-css-extract-plugin
export default {"student-badges__content":"studentBadges_student-badges__content__Y2Q0o"};